import { NextComponentType } from 'next'
import { ViocIndexPageTemplate } from '../../components/ViocPage'
import { getViocCopy } from '../../components/ViocPage/viocCopy'
import { formatPhoneNumber } from '../../components/utils/string-utils'
import { CityPhoneNumberData } from '../../components/SEMPage/CityPhoneNumberData'

const ViocEsPage: NextComponentType<
  any,
  any,
  { rating: string; reviewCount: number; sessionId: string }
> = ({ rating = '4.94', reviewCount = 6013 }) => {
  const phoneNumber = CityPhoneNumberData.generalValvoline.phoneNumber
  const phoneNumberTxt = formatPhoneNumber(phoneNumber)
  return (
    <ViocIndexPageTemplate
      copy={getViocCopy('es')}
      rating={rating}
      reviewCount={reviewCount}
      phoneNumberTxt={phoneNumberTxt}
      phoneNumber={phoneNumber}
    />
  )
}

export default ViocEsPage
